module.exports = __webpack_public_path__ + "img/account.0333af9a.svg";